import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';

@Injectable()
export class TokenGuard  {

  constructor(private messengerService: MessengerService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const reset_token = route.queryParams.token;
    if (route.queryParams.outlet && route.queryParams.outlet === 'reset') {
      this.router.navigateByUrl('(auth:auth/(authentication:reset))?token=' + reset_token, { replaceUrl: true });
      return Promise.resolve(false);
    }
    return this.messengerService.validateResetToken(reset_token).then(result => {
      if (result) {
        this.messengerService.setResetPasswordData(result);
        return Promise.resolve(true);
      } else {
        this.router.navigateByUrl('(auth:auth/(authentication:message))?messagetype=invalidToken', { replaceUrl: true });
        return Promise.resolve(false);
      }
    }, err => {
      this.router.navigateByUrl('(auth:auth/(authentication:message))?messagetype=invalidToken', { replaceUrl: true });
      return Promise.resolve(false);
    });
  }
}
